import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 35"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-width": "2.475"
    }, [
      _createElementVNode("path", { d: "M24.094 14.097c.965-.956.965-2.494.965-5.57s0-4.615-.965-5.571m0 11.14c-.965.957-2.518.957-5.623.957h-6.589c-3.105 0-4.658 0-5.623-.956M24.094 2.956C23.129 2 21.576 2 18.471 2h-6.589c-3.105 0-4.658 0-5.623.956m0 0c-.965.956-.965 2.494-.965 5.57s0 4.615.965 5.57m10.565-5.57a1.64 1.64 0 0 1-1.648 1.632c-.91 0-1.647-.73-1.647-1.632s.738-1.631 1.647-1.631c.91 0 1.648.73 1.648 1.631Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        d: "M25.059 6.895c-2.73 0-4.941-2.192-4.941-4.895m4.94 8.158c-2.728 0-4.94 2.191-4.94 4.895M5.294 6.895c2.729 0 4.941-2.192 4.941-4.895m-4.94 8.158c2.728 0 4.94 2.191 4.94 4.895M2 32.003h3.722c1.665 0 3.348.17 4.968.502 2.867.585 5.885.655 8.78.191m-1.532-5.378q.295-.035.567-.078c1.5-.237 2.76-1.031 3.914-1.895l2.977-2.227c1.05-.785 2.607-.785 3.656 0 .945.706 1.234 1.87.637 2.818-.697 1.107-1.678 2.522-2.62 3.386m-9.131-2.004-.18.02m.18-.02c.24-.051.478-.198.702-.392 1.06-.916 1.126-2.46.207-3.482a3.1 3.1 0 0 0-.74-.6C13.499 20.124 6.33 22.197 2 25.239m15.938 2.08a1 1 0 0 1-.18.02m0 0c-.863.087-1.871.11-2.99.005"
      })
    ], -1)
  ]))]))
}
export default { render: render }